export const API_BASE_URL = "https://onza-api.ibm.kg";